<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <h2>{{ $t('modals.renameDossier.title') }}</h2>
      <p>{{ $t('modals.renameDossier.prompt', { originalName }) }}</p>

      <input
        v-model="newName"
        type="text"
        class="form-control rename-input-modal"
        :placeholder="$t('modals.renameDossier.namePlaceholder')"
        maxlength="75"
        ref="renameInput"
      >
      <small class="char-counter">{{ newName.length }} / 75</small>

      <div class="modal-actions">
        <button class="btn btn-secondary" @click="cancel">{{ $t('common.cancel') }}</button>
        <button class="btn tech-purple" @click="confirm" :disabled="!newName.trim()">{{ $t('common.rename') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RenameDossierModal',
  props: {
    originalName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      newName: this.originalName
    };
  },
  mounted() {
    // Automatically focus the input when the modal appears
    this.$nextTick(() => {
      this.$refs.renameInput.focus();
    });
  },
  methods: {
    confirm() {
      if (this.newName.trim()) {
        this.$emit('confirm', this.newName.trim());
      }
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  text-align: center;
  width: 90%;
  max-width: 450px;
}

.modal-content h2 {
  margin-bottom: 15px;
}

.modal-content p {
  margin-bottom: 20px;
  font-size: 1rem;
  color: #555;
}

.rename-input-modal {
  width: 100%;
  margin-bottom: 5px;
}

.char-counter {
  display: block;
  text-align: right;
  font-size: 0.8rem;
  color: #888;
  margin-bottom: 20px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
